import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import './ShopDiscover.scss';

import { syncShopFeatures } from '../../Actions/FeaturedActions';

import ScrollToTop from '../../Components/General/ScrollToTop';
import ShopDiscoverHeader from '../../Components/Shop/ShopDiscoverHeader';
import ShopDiscoverResults from '../../Components/Shop/ShopDiscoverResults';
import ShopDiscoverTabs from '../../Components/Shop/ShopDiscoverTabs';

import { getMarketingDescriptionForType } from '../../Helpers/shop_helpers';
import { scrollToTop, getUrlParam, setUrlParam, removeUrlParam } from '../../Helpers/helpers';

const ShopDiscover = props => {
  // Tab Options
  const tab = props.match?.params?.tab;

  // Active Section
  const [activeSection, setActiveSection] = React.useState(getUrlParam('section') || undefined);

  // Sync Data
  React.useEffect(() => {
    props.syncShopFeatures();
  }, []);

  // Tab Events
  React.useEffect(() => {
    window.__ADD_EVENT__('Shop - Discover - Viewed Tab', { tab });
  }, [tab]);

  // Sync activeSection from URL on mount and when URL changes
  React.useEffect(() => {
    const urlSection = getUrlParam('section') || undefined;
    setActiveSection(urlSection);
  }, [props.location?.search]);

  // On activeSection change, set/remove URL param
  React.useEffect(() => {
    if (activeSection) setUrlParam('section', activeSection);
    else removeUrlParam('section');
  }, [activeSection]);

  // Show tabs
  const showTabs = ['categories', 'brands'].includes(tab);

  // Exclusions by tab when no section is selected
  const excludeLabel = tab === 'brands' && !activeSection ? 'NYFW' : undefined;

  // SEO
  let seo_header;
  if (tab === 'categories') seo_header = 'Shop By Category | ShopMy';
  else if (tab === 'brands') seo_header = 'Shop By Brand | ShopMy';
  else if (tab === 'curators') seo_header = 'Shop By Curator | ShopMy';
  else if (tab === 'circles') seo_header = 'Shop By Circle | ShopMy';

  // Next Buttons
  let prevBtn, nextBtn;
  const curatorsBtn = { display: 'Shop by Curator', to: '/shop/discover/curators' };
  const circlesBtn = { display: 'Shop by Circle', to: '/shop/discover/circles' };
  const brandsBtn = { display: 'Shop by Brand', to: '/shop/discover/brands' };
  const categoriesBtn = { display: 'Shop by Category', to: '/shop/discover/categories' };
  if (tab === 'curators') [prevBtn, nextBtn] = [circlesBtn, brandsBtn];
  else if (tab === 'circles') [prevBtn, nextBtn] = [brandsBtn, categoriesBtn];
  else if (tab === 'brands') [prevBtn, nextBtn] = [categoriesBtn, curatorsBtn];
  else if (tab === 'categories') [prevBtn, nextBtn] = [curatorsBtn, circlesBtn];

  return (
    <div className='shop-discover-outer-container'>
      <MetaTags>
        <title>{seo_header}</title>
        <meta property='og:title' content={seo_header} />
        <meta property='description' content={getMarketingDescriptionForType(tab)} />
        <meta property='og:description' content={getMarketingDescriptionForType(tab)} />
      </MetaTags>
      <ScrollToTop />
      <div className='shop-discover-inner-container'>
        <div className='shop-discover-header-outer-container'>
          <ShopDiscoverHeader tab={tab} activeSection={activeSection} excludeLabel={excludeLabel} />
        </div>
        {showTabs && (
          <div className='shop-discover-tabs-outer-container'>
            <ShopDiscoverTabs tab={tab} activeSection={activeSection} setActiveSection={setActiveSection} />
          </div>
        )}
        <div className='shop-discover-results-outer-container'>
          <ShopDiscoverResults tab={tab} activeSection={activeSection} excludeLabel={excludeLabel} />
        </div>
        <div className='shop-discover-more-outer-container'>
          <div className='shop-discover-more-buttons'>
            {prevBtn && (
              <Link to={prevBtn.to} className='shop-discover-more-button' onClick={scrollToTop}>
                {prevBtn.display}
              </Link>
            )}
            {nextBtn && (
              <Link to={nextBtn.to} className='shop-discover-more-button' onClick={scrollToTop}>
                {nextBtn.display}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

ShopDiscover.propTypes = {
  user: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  syncShopFeatures
})(ShopDiscover);
